// src/components/Auth/PrivateRoute.jsx
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <div className="text-center py-10">Loading...</div>; // ⏳ Wait until fetch is done

  return user ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
